import {
  headCells,
  headCellsAdmin,
  headCellsCompanyManager,
  headCellsInsights,
  headCellsInsightsOutsideSales,
  headCellsManager,
  headCellsOrder,
  productionHeadCells,
  companyManagerOrderheadCells,
  dealerOrderheadCells,
  managerOrderheadCells,
  outsideSalesHeadOrder,
  outsideSalesHead,
} from "./headCells";

const head = (tab: string, displayLeadNumberColumn?: boolean) => {
  const role = JSON.parse(sessionStorage.getItem("role") || JSON.stringify(""));
  const dealer = JSON.parse(
    sessionStorage.getItem("dealer") || JSON.stringify(""),
  );

  const leadNumberColumn = {
    id: "view",
    numeric: false,
    disablePadding: true,
    label: "Lead Number",
  };

  if (tab === "Insights") {
    if (role === "Outside Sales") {
      return !displayLeadNumberColumn
        ? headCellsInsightsOutsideSales
        : [...headCellsInsightsOutsideSales.slice(0, 6), leadNumberColumn, ...headCellsInsightsOutsideSales.slice(6)];
    }
    return !displayLeadNumberColumn
      ? headCellsInsights
      : [...headCellsInsights.slice(0, 6), leadNumberColumn, ...headCellsInsights.slice(6)];
  }

  if (role === "Dealer") {
    return tab === "Quotes"
      ? headCells
      : dealer.startsWith("Golden State")
        ? [
            { id: "view", numeric: false, disablePadding: true, label: "" },
            ...dealerOrderheadCells,
          ]
        : dealerOrderheadCells;
  }

  if (role === "Manager") {
    return tab === "Quotes"
      ? headCellsManager
      : dealer.startsWith("Golden State")
        ? [
            { id: "view", numeric: false, disablePadding: true, label: "" },
            ...managerOrderheadCells,
          ]
        : managerOrderheadCells;
  }

  if (role === "Company Manager" || role === "Manager II") {
    return tab === "Quotes"
      ? headCellsCompanyManager
      : dealer.startsWith("Golden State")
        ? [
            { id: "view", numeric: false, disablePadding: true, label: "" },
            ...companyManagerOrderheadCells,
          ]
        : companyManagerOrderheadCells;
  }

  if (role === "Admin" || role === "Inside Sales") {
    return tab === "Quotes" ? headCellsAdmin : headCellsOrder;
  }

  if (role === "Outside Sales") {
    return tab === "Quotes" ? outsideSalesHead : outsideSalesHeadOrder;
  }

  if (role === "Production") {
    return productionHeadCells;
  }
};

export default head;
